import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import PageTitle from "../components/PageTitle";
import { ActionButton, Buttons } from "../components/Buttons";
import { FaMagnifyingGlass } from "react-icons/fa6";
import TableUI from "../components/TableUI";
import { MdOutlineDelete } from "react-icons/md";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { LiaEditSolid } from "react-icons/lia";
import { fetchInvoicesByAgent, deleteInvoice } from "../slices/invoiceSlice";
import NotifyData from "../components/NotifyData";
import Pagnation from "../components/Pagnation";
import { LuPrinter } from "react-icons/lu";
import { TextInputForm } from "../components/Forms";

const AgentInvoices = () => {
  const dispatch = useDispatch();
  const { agentName } = useParams();
  const navigate = useNavigate();
  const { agentInvoices } = useSelector((state) => state.invoice);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  // Fetch agent-specific invoices
  useEffect(() => {
    dispatch(fetchInvoicesByAgent(decodeURIComponent(agentName)));
  }, [dispatch, agentName]);

  // Handle delete
  const handleDelete = async (id) => {
    try {
      await dispatch(deleteInvoice(id)).unwrap();
      NotifyData("Invoice Deleted Successfully", "success");
    } catch (error) {
      NotifyData("Invoice Deletion Failed", "error");
    }
  };

  // Edit invoice
  const handleEdit = (invoice) => {
    navigate("/create-invoice", { state: { invoice } });
  };

  // Print invoice
  const handlePrint = (invoice) => {
    navigate("/billpreview", { state: { invoice } });
  };

  // Navigate to Balance Sheet for this agent
  const handleBalanceSheet = () => {
    navigate(`/agent-balance-sheet/${encodeURIComponent(agentName)}`);
  };

  // Search filter
  const filteredInvoices =
    agentInvoices?.filter((item) =>
      (item.customer_name || "")
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    ) || [];

  // Pagination Logic
  const total = filteredInvoices.length;
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const currentData = filteredInvoices.slice(startIndex, endIndex);

  // Table headers
  const InvoiceHead = [
    "No",
    "Invoice No",
    "Customer Name",
    "Mobile Number",
    "Total",
  ];

  // Table data
  const InvoiceData = currentData.map((item, index) => ({
    values: [
      startIndex + index + 1,
      item.invoice_no,
      item.customer_name,
      item.mobile_number,
      `Rs.${item.grand_total}`,
      <ActionButton
        options={[
          {
            label: "Print",
            icon: <LuPrinter />,
            onClick: () => handlePrint(item),
          },
          {
            label: "Edit",
            icon: <LiaEditSolid />,
            onClick: () => handleEdit(item),
          },
          {
            label: "Delete",
            icon: <MdOutlineDelete />,
            onClick: () => handleDelete(item.id),
          },
        ]}
        label={<HiOutlineDotsVertical />}
      />,
    ],
  }));

  const handleBack = () => {
    navigate("/invoices");
  };

  return (
    <div id="main">
      <Container fluid>
        <Row>
          {/* Title */}
          <Col lg="6" className="py-3">
            <PageTitle
              PageTitle={`Agent Name → ${decodeURIComponent(agentName)}`}
              showButton={false}
            />
          </Col>

          {/* Back and Balance Sheet buttons */}
          <Col lg="6" className="py-3 text-end">
            {/* <Buttons
              label="Back to Invoices"
              classname="crud-btn me-2"
              OnClick={handleBack}
            /> */}
            <Buttons
              label="Balance Sheet"
              classname="crud-btn"
              OnClick={handleBalanceSheet}
            />
          </Col>

          {/* Search bar */}
          <Col lg="3" className="align-self-center py-2">
            <TextInputForm
              prefix_icon={<FaMagnifyingGlass />}
              PlaceHolder="Search by Customer Name"
              className="form-control-padleft"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1); // Reset to first page when searching
              }}
            />
          </Col>

          {/* Table */}
          <Col lg="12" xs="12">
            <TableUI
              headers={InvoiceHead}
              body={InvoiceData}
              className="table-end"
            />
          </Col>

          {/* Pagination */}
          <Col lg="12" xs="12" className="d-flex justify-content-end py-3">
            <Pagnation
              total={total}
              currentPage={currentPage}
              pageSize={pageSize}
              onPageChange={(page) => setCurrentPage(page)}
              onPageSizeChange={(current, size) => {
                setPageSize(size);
                setCurrentPage(1);
              }}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AgentInvoices;
